import { useContext } from 'react';

import { CmsContentContext } from './cms-content-context';

export const useCmsContent = () => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useContext(CmsContentContext)!;
};

export type CmsContent = ReturnType<typeof useCmsContent>;
